@let currentPageId = this.pageId();
@let viewConfig = this.pageViewConfig();
@let availableItems = this.availableItems();
@let currentLanguage = this.currentLanguage();

@if (viewConfig.theme?.background?.image; as image) {
  <app-image
    class="bg-image"
    [image]="image | imageTranslate: currentLanguage"
    alt="Background Image"
  />
}

<app-header
  class="header"
  coreActivitySection="Header"
  [pageName]="pageName() | textTranslate:' fallback'"
  [backSwipe]="backSwipeConfig"
>
  @if (viewConfig.header && viewConfig.header.title && viewConfig.header.title.text) {
    <app-header-text slot="center" [text]="viewConfig.header.title.text | textTranslate: currentLanguage"/>
  }

  @if (!viewConfig.header || !viewConfig.header.badge ||
  (viewConfig.header && viewConfig.header.badge && viewConfig.header.badge.type === 'table-name')) {
    <app-header-badge-table-name slot="right"/>
  } @else if (viewConfig.header && viewConfig.header.badge && viewConfig.header.badge.type === 'text') {
    <app-header-badge-text slot="right" [text]="viewConfig.header.badge.text | textTranslate: currentLanguage"/>
  }
</app-header>

@if (viewConfig.logo) {
  @let logo = viewConfig.logo | imageTranslate: currentLanguage;

  <div class="logo">
    <app-image
      class="image"
      [image]="logo"
      alt="Logo"
    />
  </div>
}

@if (viewConfig.title) {
  <app-text class="title">{{ viewConfig.title | textTranslate: currentLanguage }}</app-text>
}

@if (availableItems.length > 0) {
  <app-scroll>
    <div
      class="buttons"
      [class.grid]="viewConfig.layout === 'grid'"
      coreActivitySection="Buttons"
    >
      @let oddNumberOfItems = availableItems.length % 2 !== 0;
      @let pageIdsWithCallWaiter = this.pageIdsWithCallWaiter();

      @for (item of availableItems; track item.id; let last = $last) {
        @if (item.type === 'button' && item.action.type === 'page') {
          @let labelFallback = item.label | textTranslate:'fallback';

          <button
            class="button"
            [class.full-width]="viewConfig.layout === 'grid' && oddNumberOfItems && last"
            [routerLink]="['/', 'main', 'page', item.action.pageId]"
            [queryParams]="{ ref: `page:${ currentPageId }` | refLinkParams }"
            [coreUserActivityClickTracking]="`Open ${ labelFallback }`"
          >
            @if (item.icon) {
              @let icon = item.icon | imageTranslate: currentLanguage;

              <app-image
                class="icon"
                [image]="icon"
                [alt]="labelFallback"
              />
            }

            <div class="content">
              <app-text class="label">{{ item.label | textTranslate: currentLanguage }}</app-text>

              @if (item.description) {
                <app-text class="description">{{ item.description | textTranslate: currentLanguage }}</app-text>
              }
            </div>

            @if (pageIdsWithCallWaiter?.includes(item.action.pageId)) {
              <app-call-waiter-indicator class="indicator"/>
            }
          </button>
        }

        @if (item.type === 'image-button' && item.action.type === 'page') {
          @let backgroundColor = item.theme && item.theme.background && item.theme.background.color
            ? (item.theme.background.color | colorTranslate: currentLanguage)
            : undefined;

          @let borderColor = item.theme && item.theme.border && item.theme.border.color
            ? (item.theme.border.color | colorTranslate: currentLanguage)
            : undefined;

          <button
            class="button with-image"
            [style.background-color]="backgroundColor"
            [style.border-color]="borderColor"
            [class.full-width]="viewConfig.layout === 'grid' && oddNumberOfItems && last"
            [routerLink]="['/', 'main', 'page', item.action.pageId]"
            [queryParams]="{ ref: `page:${ currentPageId }` | refLinkParams }"
            [coreUserActivityClickTracking]="`Open ${ item.name }`"
          >
            @let image = item.image | imageTranslate: currentLanguage;

            <app-image
              class="image"
              [image]="image"
              [alt]="item.name"
            />

            @if (pageIdsWithCallWaiter?.includes(item.action.pageId)) {
              <app-call-waiter-indicator class="indicator"/>
            }
          </button>
        }
      }
    </div>
  </app-scroll>
} @else {
  <app-text class="empty">
    {{ viewConfig.emptyState.message | textTranslate: currentLanguage }}
  </app-text>
}
